<template>
  <v-main>
    <button class="btn btn-secondary back" @click="$router.push('/compset')">
      Back to Overview &lt;&lt;
    </button>
    <div class="outer-container">
      <div class="instructions">
        <b>Instructions: </b>Use the search bar to find locations, hover over
        their icons to view details and click to add to location compset
      </div>

      <div class="inner-container">
        <div class="sidebar">
          <div class="sidebar__search">
            <compset-map-search @new-search="onNewSearch" ref="mapSearch" />
          </div>
          <div class="sidebar__list">
            <div
              :class="[{ chosen: location.chosen }, 'sidebar__list__item']"
              :key="location.id"
              v-for="location in locations"
            >
              <h5>{{ location.name }}</h5>
              {{ location.address }}
            </div>
          </div>
        </div>
        <compset-map
          :key="locations.length"
          :locations="locations"
          @map-ready="onMapReady"
          @location-clicked="onLocationClick"
          class="map"
          ref="map"
        />
      </div>
    </div>
    <button type="button" class="btn btn-primary" @click="updateCompset">
      Save
    </button>
  </v-main>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CompsetMap from "../components/compset/CompsetMap.vue";
import CompsetMapSearch from "../components/compset/CompsetMapSearch.vue";
import { getCompsetLocations, updateLocationCompset } from "@/api/compset";

export default {
  name: "compset-map-view",

  components: {
    "compset-map": CompsetMap,
    "compset-map-search": CompsetMapSearch
  },

  data() {
    return {
      locations: [],
      google: null,
      map: null
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Compset" }]);
    this.$store.commit("setLocationVisibile", true);
  },
  async created() {
    const locations = await getCompsetLocations(
      this.$route.params.selectedLocationId
    );
    if (locations) {
      console.log(locations);
      this.locations = locations.map(location => ({
        id: location.place_id,
        name: location.name,
        address: location.address,
        position: { lat: location.lat, lng: location.lng },
        chosen: true,
        infoWindow: {
          open: false,
          options: {
            content: `<p>Name: ${location.name}</p><p>Address: ${location.address}</p>`,
            pixelOffset: {
              width: 0,
              height: -35
            }
          }
        }
      }));
    } else {
      this.locations = [];
    }
  },

  methods: {
    onMapReady({ google, map }) {
      this.google = google;
      this.map = map;

      this.$refs.mapSearch.initSearch(this.google, this.map);
    },
    onLocationClick(locationId) {
      const locationIndex = this.locations.findIndex(
        location => location.id == locationId
      );
      this.locations[locationIndex].chosen = !this.locations[locationIndex]
        .chosen;
    },

    onNewSearch(searchResults) {
      if (!searchResults) return;
      this.removeOldSearchResults();

      if (searchResults.len > 10) {
        searchResults = searchResults.slice(0, 10);
      }

      searchResults.forEach(location => {
        if (location.geometry && location.geometry.location) {
          if (
            !this.locations.find(
              oldLocation => oldLocation.id == location.place_id
            )
          ) {
            this.locations.push({
              id: location.place_id,
              name: location.name,
              address: location.formatted_address,
              position: {
                lat: location.geometry.location.lat(),
                lng: location.geometry.location.lng()
              },
              chosen: false,
              infoWindow: {
                open: false,
                options: {
                  content: `<p>Name: ${location.name}</p><p>Address: ${location.formatted_address}</p>`,
                  pixelOffset: {
                    width: 0,
                    height: -35
                  }
                }
              }
            });
          }
        }
      });

      this.$refs.map.displayLocations();
    },

    removeOldSearchResults() {
      this.locations.filter(location => location.chosen);
    },

    async updateCompset() {
      const locations = this.locations.map(location => ({
        place_id: location.id,
        name: location.name,
        address: location.address,
        lat: location.position.lat,
        lng: location.position.lng,
        chosen: location.chosen
      }));

      const res = await updateLocationCompset(
        this.$route.params.selectedLocationId,
        { compset: locations }
      );

      if (res.status >= 400) {
        console.error(res);
      }
    }
  }
};
</script>

<style scoped>
.outer-container {
  height: 85%;
  background: rgba(0, 0, 30, 0.02);
  padding: 2rem;
  border-radius: 4px;
  min-width: 600px;
}

.instructions {
  margin-bottom: 2rem;
}

.inner-container {
  height: 400px;
  display: flex;
  background: white;
  border-radius: 4px;
}

.sidebar {
  flex: 1;
  padding: 1rem;
}

.sidebar__search {
  margin-bottom: 1rem;
}

.sidebar__list {
  height: 90%;
  overflow-y: scroll;
}

.sidebar__list__item {
  border-bottom: 1px solid gray;
  padding: 1rem;
  background: rgba(255, 0, 0, 0.1);
}

.sidebar__list__item.chosen {
  background: rgba(0, 204, 0, 0.1);
}

.map {
  flex: 3;
}

.btn-primary {
  margin: 1rem;
  float: right;
  min-width: 80px;
}

.back {
  margin-bottom: 1rem;
}
</style>
